export const NiBConstant = {
    EXPERIMENT_KEY: 'lca_download_app_notify_modal',
    VARIABLE_BANNER_OBJECT: 'download_app_content',
    EVENTS_CLICK_APP_STORE: 'appstore_click',
    EVENTS_CLICK_GOOGLE_PLAY: 'googleplay_click',
    VIEW_DOWNLOAD_APP_COMPONENT: 'view_download_app_component',
};
//# sourceMappingURL=constants.js.map